import React from 'react';

interface CloseRoundedIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const CloseRoundedIcon: React.FC<CloseRoundedIconProps> = ({
  width = 14,
  height = 14,
  color = '#A5A4AA',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.00003 5.93288L1.73337 9.19954C1.61114 9.32177 1.45559 9.38288 1.2667 9.38288C1.07781 9.38288 0.922255 9.32177 0.800032 9.19954C0.67781 9.07732 0.616699 8.92177 0.616699 8.73288C0.616699 8.54399 0.67781 8.38843 0.800032 8.26621L4.0667 4.99954L0.800032 1.73288C0.67781 1.61066 0.616699 1.4551 0.616699 1.26621C0.616699 1.07732 0.67781 0.921766 0.800032 0.799544C0.922255 0.677322 1.07781 0.616211 1.2667 0.616211C1.45559 0.616211 1.61114 0.677322 1.73337 0.799544L5.00003 4.06621L8.2667 0.799544C8.38892 0.677322 8.54448 0.616211 8.73337 0.616211C8.92226 0.616211 9.07781 0.677322 9.20003 0.799544C9.32225 0.921766 9.38337 1.07732 9.38337 1.26621C9.38337 1.4551 9.32225 1.61066 9.20003 1.73288L5.93337 4.99954L9.20003 8.26621C9.32225 8.38843 9.38337 8.54399 9.38337 8.73288C9.38337 8.92177 9.32225 9.07732 9.20003 9.19954C9.07781 9.32177 8.92226 9.38288 8.73337 9.38288C8.54448 9.38288 8.38892 9.32177 8.2667 9.19954L5.00003 5.93288Z"
      fill={color}
    />
  </svg>
);

export default CloseRoundedIcon;
